import * as React from "react";

import { makeStyles } from "@material-ui/core";

import { useMerchantModel, useTranslation } from "client/hooks";

const useStyles = makeStyles(() => ({
  text: {
    fontSize: "0.9rem",
  },
}));

export const StreetAddressHelperText: React.FC = () => {
  const classes = useStyles();
  const t = useTranslation();

  const { merchant } = useMerchantModel();

  if (merchant.companyInformation.registeredCountry.value === "New Zealand") {
    return null;
  }
  return <span className={classes.text}>{t("businessStreet_HelperText")}</span>;
};
